import { Component } from "react"
import Spinner from 'react-bootstrap/Spinner';
import Table from "react-bootstrap/Table"
import { BsFillXSquareFill } from 'react-icons/bs'
import { TiTick } from 'react-icons/ti'
import NavBar from "../../Layout/Nav";
import { AppContext } from "../../../context/AppContext";
import { Modal } from "react-bootstrap";

class wealthManagement extends Component {
    state = {
        usersData: [],
        isLoading: true,
        user: {}
    }
    static contextType = AppContext;

    componentDidMount() {
        this.fetchData()
    }

    fetchData = async () => {


        const response = await fetch(`${process.env.REACT_APP_APIURL}/wealthmanaement/users`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${this.context.user.token}`
            }
        })

        if (response.ok) {
            const data = await response.json()
            console.log(data)
            this.setState({ usersData: data.results, isLoading: false })
        } else {
            const data = await response.json()
            console.log(response, data)
            alert("please try logging in again and check it ")
        }
    }


    updateStatusToSent = async (id) => {
        const response = await fetch(`${process.env.REACT_APP_APIURL}/wealthmanaement/${id}/user`, {
            method: "PATCH",
            headers: {
                'Authorization': `Bearer ${this.context.user.token}`
            }
        })

        if (response.ok) {
            this.fetchData()
        } else {
            alert('Unable to update...!!  please try again')
        }
    }

    viewDetailedView = (user) => {
        console.log(user)
        this.setState({ user })
        // this.props.history.push("/products/ncd/user", { user: user })
    }


    render() {
        const { isLoading, usersData, user } = this.state
        return (
            <>
                <NavBar />
                <div className="pt-4 mt-5">

                    <h1 >wealth management</h1>
                    {
                        isLoading ?
                            <div className="h-100 w-100 d-flex justify-content-center align-items-center">
                                <Spinner animation="border" variant='success' />
                            </div>
                            :
                            <div className="p-3 text-center d-flex flex-row justify-content-center ">
                                <Table className="rounded w-50" striped bordered hover responsive>

                                    <thead variant="dark" style={{ backgroundColor: "black", color: 'white' }}>
                                        <tr>
                                            <td>Name</td>
                                            {/* <td>Mobile</td>
                                            <td>location</td>
                                            <td>employment type </td>
                                            <td>email</td>
                                            <td>annual income</td> */}
                                            <td >view</td>
                                            <td >status</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usersData.map((each, index) => (
                                            <tr key={index} >
                                                <td className="text-left">{each.name}</td>
                                                {/* <td>{each.mobile}</td>
                                                <td>{each.location}</td>
                                                <td>{each.employementType}</td>
                                                <td>{each.email}</td>
                                                <td>{each.annualIncome}</td> */}
                                                {/* <td>{each.contactStatus !== 0 ? <span className="text-success">Sent <TiTick /></span> : <span className="text-danger">Not Sent <BsFillXSquareFill /></span>}</td> */}
                                                <td>
                                                    <button onClick={() => {
                                                        this.viewDetailedView(each)
                                                    }} className={`btn text-decoration-underline text-primary`} >
                                                        view
                                                    </button>
                                                </td>
                                                <td>
                                                    <button onClick={() => {
                                                        this.updateStatusToSent(each.uid)
                                                    }} className={`btn ${each.contactStatus === 0 ? "btn-primary" : "btn-success"}`} disabled={each.contactStatus !== 0}>
                                                        {each.contactStatus === 0 ? 'Contact' : "Contacted"}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                                <div className="text-left border m-2 w-50 p-2">
                                    <h3 className="text-decoration-underline"> User Details</h3>
                                    <div >
                                        <b >Name:    </b><span >{user.name}</span>
                                    </div>
                                    <div >
                                        <b >Mobile:    </b><span >{user.mobile}</span>
                                    </div>
                                    <div >
                                        <b >Email:    </b><span >{user.email}</span>
                                    </div>
                                    <div >
                                        <b >City:    </b><span >{user.city}</span>
                                    </div>
                                    <div >
                                        <b >Amount Investment:   </b><span >{user.amountOfInvestment}</span>
                                    </div>
                                    <div >
                                        <b >category Investment:   </b><span >{user.categoryInvestment}</span>
                                    </div>
                                    <div >
                                        <b >applicationDate:   </b><span >{user.applicationDate}</span>
                                    </div>
                                    {user.contactStatus === 0 ? <button onClick={() => {
                                        this.updateStatusToSent(user.uid)
                                    }} className={`btn mt-4 ${user.contactStatus === 0 ? "btn-primary" : "btn-success"}`} disabled={user.contactStatus !== 0}>
                                        {user.contactStatus === 0 ? 'Contact' : "Contacted"}
                                    </button> :
                                        <div >
                                            <b >Status:    </b><span >Contacted</span>
                                        </div>

                                    }

                                </div>
                            </div>
                    }
                </div>
            </>

        )
    }
}

export default wealthManagement